import React from 'react';

import styled from '@emotion/styled';

import { Countrylist } from 'src/services/responseTypes/singleLaunchResponse';

import * as style from './SocialMediaIconsContainerStyles';
import { mixpanelObject } from '../../../utils/analytics';
import {
  timeEvent,
  ctaEvent
} from '../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../../utils/analytics/mixpanel/mixpanelHelper';
import {
  AppStoreAlt,
  AppStoreLinks,
  CONNECT_WITH_US,
  DOWNLOAD_APPS,
  FOOTER_STORE_SOCIAL_LINKS,
  FOOTER_STORE_SOCIAL_LINKS_GLOBAL
} from '../../../utils/constants/FooterConstants';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_BUTTON,
  MIXPANEL_LINK,
  MIXPANEL_GOOGLE_PLAY_STORE,
  MIXPANEL_APPLE_PLAY_STORE,
  MIXPANEL_FACEBOOK,
  MIXPANEL_INSTAGRAM,
  MIXPANEL_TWITTER,
  MIXPANEL_YOUTUBE
} from '../../../utils/analytics/mixpanel/mixpanelConstants';

// styled components
const AppStoresContainer = styled.div`
  ${style.appStoresContainer};
`;
const SocialMediaContainer = styled.div`
  ${style.socialMediaContainer};
`;

// functions
const trackMixPanelEvents = (element: string) => {
  timeEvent();
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);
  mixpanelObject.setProperty(MIXPANEL_BUTTON, MIXPANEL_LINK);
  ctaEvent();
};

const handleLinkClick = (element: string) => () => {
  trackMixPanelEvents(element);
};
type IconsProps = {
  global: boolean;
  countryList?: Countrylist[];
};

const SocialMediaIconsContainer = ({ global, countryList }: IconsProps) => {
  const {
    footer_options: {
      facebook: countryListFacebook = '',
      twitter: countryListTwitter = '',
      instagram: countryListInstagram = '',
      youtube: countryListYoutube = ''
    } = {}
  } = countryList?.[0] || {};

  const { ANDROID, IOS, FACEBOOK, TWITTER, INSTAGRAM, YOUTUBE } = global
    ? FOOTER_STORE_SOCIAL_LINKS_GLOBAL
    : FOOTER_STORE_SOCIAL_LINKS;

  return (
    <div css={style.iconsContainer}>
      <AppStoresContainer>
        <span css={style.iconsText}>{DOWNLOAD_APPS}</span>
        <a
          href={ANDROID}
          onClick={handleLinkClick(MIXPANEL_GOOGLE_PLAY_STORE)}
          target={'_blank'}
          rel={'noreferrer noopener'}>
          <img
            src={AppStoreLinks.PLAY_STORE}
            loading="lazy"
            width="123px"
            height="37px"
            alt={AppStoreAlt.PLAY_STORE}></img>
        </a>
        <a
          href={IOS}
          onClick={handleLinkClick(MIXPANEL_APPLE_PLAY_STORE)}
          target={'_blank'}
          rel={'noreferrer noopener'}>
          <img
            src={AppStoreLinks.APP_STORE}
            loading="lazy"
            width="113px"
            height="37px"
            alt={AppStoreAlt.APP_STORE}></img>
        </a>
      </AppStoresContainer>
      <SocialMediaContainer>
        <span css={style.iconsText}>{CONNECT_WITH_US}</span>

        <a
          css={style.socialMediaIconContainer}
          title="facebook"
          onClick={handleLinkClick(MIXPANEL_FACEBOOK)}
          href={countryListFacebook || FACEBOOK}
          target="_blank"
          rel="noopener noreferrer">
          <span css={style.facebook}></span>
        </a>

        <a
          css={style.socialMediaIconContainer}
          title="instagram"
          onClick={handleLinkClick(MIXPANEL_INSTAGRAM)}
          href={countryListInstagram || INSTAGRAM}
          target="_blank"
          rel="noopener noreferrer">
          <span css={style.instagram}></span>
        </a>

        <a
          css={style.socialMediaIconContainer}
          title="twitter"
          onClick={handleLinkClick(MIXPANEL_TWITTER)}
          href={countryListTwitter || TWITTER}
          target="_blank"
          rel="noopener noreferrer">
          <span css={style.twitter}></span>
        </a>

        <a
          css={style.socialMediaIconContainer}
          title="youtube"
          onClick={handleLinkClick(MIXPANEL_YOUTUBE)}
          href={countryListYoutube || YOUTUBE}
          target="_blank"
          rel="noopener noreferrer">
          <span css={style.youtube}></span>
        </a>
      </SocialMediaContainer>
    </div>
  );
};

export default React.memo(SocialMediaIconsContainer);
